import React from 'react';
import { MenuSelect } from '.';
import configs from '../../../redux/chart-iq/chart/config';

interface IChartTypeProps {
  chartType: string,
  ciq: any,
  setChartTypeAndSave: () => void,
}

export const ChartTypes: React.FunctionComponent<IChartTypeProps> = props => {
  if (!props.ciq) {
    return <div />;
  }

  const selected = configs.chartTypes.types.find(ct => ct.type === props.chartType);

  return (
    <MenuSelect
      options={configs.chartTypes.types}
      keyName='type'
      name='label'
      handleOptionSelect={props.setChartTypeAndSave}
      needsCiq={true}
      ciq={props.ciq}
      menuId='chartTypeSelect'
      title='Chart'
      hasCheckboxes={true}
      selected={selected}
    />
  );
};